module.exports = __webpack_public_path__ + "static/media/Concept_EarthArcades.a95c55d2.jpg";